import { Brick, registerBrick } from 'olympe';
import jsC8 from "jsc8";

export default class MacrometaClient extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} apikey
     * @param {string} domain
     * @param {function(*)} setClient
     */
    update($, [apikey, domain], [setClient]) {
        // Write your code here.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed the first time when all inputs have a value
        // and then anytime an input receives a new value.
        // Override `setupExecution()` to change this behavior.
        const client = jsC8({
            url: "https://"+domain,
            apiKey: apikey,
            fabricName: "_system",
          });
        setClient(client);
    }
}

registerBrick('018ef06fa327d909a765', MacrometaClient);
